module.exports = __webpack_public_path__ + "media/images/banks/uob-a6524e249b7f6d01bd6b8bf02d00817b.png";